import React, {useEffect, useState, useRef} from "react";
import {useNavigate} from "react-router-dom";
import {loadScriptsSequentially} from "../utils";
import {useModal} from "../backend/ModalContext";
import "./LandingPage2.css";
import {subscribeNewsletter} from "../backend/api";

function TotemTouch() {
    const navigate = useNavigate();
    // const [sites, setSites] = useState([]);
    const formRef = useRef(null); // Riferimento alla sezione del form

    useEffect(() => {
        // Carica jQuery e altri script necessari
        const script = document.createElement("script");
        script.src =
            "https://app.huberway.org/assets/plugins/jquery/jquery-3.2.1.min.js?v=" +
            Date.now();
        script.onload = () => {
            loadScriptsSequentially([
                "js/pre-loader.js",
                "assets/bootstrap/js/popper.min.js",
                "assets/bootstrap/js/bootstrap.min.js",
                "js/parallaxie.js",
                "js/TweenMax.min.js",
                "js/jquery.wavify.js",
                "assets/wow/wow.min.js",
                "assets/counterup/jquery.counterup.min.js",
                "assets/counterup/jquery.waypoints.min.js",
                "js/main.js",
            ]);
        };

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);
    // Funzione per scrollare fino al form con un offset personalizzato
    const scrollToForm = () => {
        const offset = -80; // Regola questo valore in base alle tue esigenze
        const formPosition =
            formRef.current.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({top: formPosition + offset, behavior: "smooth"});
    };

    function handleSubmit(e) {
        e.preventDefault();

        const name = document.getElementById("NAME").value;
        const nominativo = document.getElementById("NOMINATIVO").value;
        const shop = document.getElementById("SHOP").value;
        const phone = document.getElementById("PHONE").value;
        const email = document.getElementById("EMAIL").value;
        const luogo = document.getElementById("LUOGO").value;

        if (!name || !nominativo || !shop || !phone || !email || !luogo) {
            return;
        }

        subscribeNewsletter(email, name, shop, phone, nominativo, luogo).then(() => {
            navigate("/thankspage");
        });
    }

    return (
        <>
            <header style={{marginTop: "100px"}} className="">
                <div className="container">
                    <div className="section_title text-center">
                        <h1 className="fw-bolder text-wrap text-break fs-2 fs-sm-1 fs-md-1">
                            L’EVOLUZIONE DELLO SHOPPING
                        </h1>
                        <h4 className="text-center fs-5 fs-md-4">
                            Non restare ancorato agli ormai obsoleti metodi di lavoro
                            tradizionali
                        </h4>
                    </div>
                </div>
            </header>

            {/* Pulsante che scrolla al form */}
            <div className="d-flex align-items-center justify-content-center mb-4 mt-4">
                <button className="btn-invia" style={{width: "200px", fontSize: "18px"}} onClick={scrollToForm}>
                    Candidati ora
                </button>

            </div>

            <div className="row justify-content-center mb-4 px-2">
                <div className="col-12 col-sm-10 col-md-8 col-lg-6">
                    <p className="text-center" style={{fontSize: "16px"}}>
                        Siamo alla ricerca di Partner pronti a ospitare i nostri Totem Touch Interattivi e vivere con
                        noi
                        nuove esperienze di vendita innovative. Diventa il punto di incontro tra il nostro brand e i
                        tuoi
                        clienti, offrendo loro un'esperienza d'acquisto personalizzata e potenziata grazie al nostro
                        Totem
                        Touch, uno strumento digitale e interattivo che unisce moda e tecnologia.
                    </p>
                </div>
            </div>

            <section className="how-it-works">
                <div className="container">
                    <h2>Opportunità di guadagno</h2>
                    <div className="cards-container">
                        {[
                            {
                                title: "Commissione di Appartenenza",
                                desc: "Quando un cliente si registra per la prima volta presso il Totem installato nel tuo store, acquisisci il diritto a ricevere una commissione del 10% su ogni acquisto che quel cliente effettuerà nei successivi 12 mesi, indipendentemente dal canale di acquisto (dal Totem, da casa o da un altro dispositivo)."
                            },
                            {
                                title: "Commissione di Vendita",
                                desc: "Se il cliente effettua un acquisto direttamente presso il tuo Totem, riceverai un ulteriore 20% sul valore dell’acquisto, oltre alla commissione per l’acquisizione del cliente. Se invece l’acquisto avviene tramite un altro Totem o grazie all’azione di un altro partner, il 20% andrà a chi ha generato la vendita, ma continuerai a ricevere il 10% di appartenenza su quel cliente."
                            },
                            {
                                title: "Commissione sulla rete di Partner",
                                desc: "I partner hanno anche l’opportunità di coinvolgere altri professionisti e individui interessati a promuovere il brand Psicopatici Italia. Chi invita un nuovo partner nella community riceverà un 2% su tutti gli acquisti generati dall’azione del partner invitato."
                            }
                        ].map((item, i) => (
                            <div key={i} className="card1" style={{display: "flex", flexDirection: "column"}}>
                                <p><strong>{item.title}</strong></p>
                                <p style={{color: "gray", fontSize: "12px"}}>{item.desc}</p>
                            </div>
                        ))}
                    </div>

                </div>
            </section>

            <div className={"flex justify-content-center"}>
                <div className={"flex flex-column align-items-center m-0 mt-3"}>
                    <h3 style={{fontWeight: 'bold'}}>Validità e rinnovo</h3>
                    <p style={{textAlign: 'center'}}>
                        La commissione del 10% per l’acquisizione del cliente è valida per 12 mesi dall’ultimo acquisto
                        effettuato. Ogni qualvolta un cliente effettua un nuovo acquisto, la durata della commissione su
                        eventuali acquisti futuri si rinnova per ulteriori 12 mesi.
                    </p>
                </div>
            </div>


            <section className="how-it-works">
                <div className="container">
                    <h2>Commissioni legate alle performance digitali</h2>

                    <p>
                        Tutti i partner che desiderano installare un Totem Touch Innovativo Psicopatici Italia nella
                        propria boutique sono tenuti ad affiancare a questa presenza fisica anche una forte attività di
                        coinvolgimento digitale. Tali partner, in tal modo, accedono così ad ulteriori benefici
                        specifici, tra cui la possibilità di guadagnare anche:
                    </p>

                    <div className="cards-container">
                        <div className="card1">
                            <p>6% per ogni nuova acquisizione cliente, tramite contenuti social.</p>
                        </div>
                        <div className="card1">
                            <p>12% su ogni acquisto generato dai clienti acquisiti digitalmente.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="how-it-works">
                <div className="container">
                    <h2>Perché diventare Partner Totem Touch?</h2>
                    <div className="cards-container">
                        <div className="card1">
                            <p>Esperienza cliente migliorata, in quanto fortemente personalizzata.</p>
                        </div>
                        <div className="card1">
                            <p>Guadagni costanti su ogni vendita generata.</p>
                        </div>
                        <div className="card1">
                            <p>Nessuna gestione di magazzino e nessun investimento iniziale.</p>
                        </div>
                        <div className="card1">
                            <p>Nessuna problematica in termini di merce invenduta.</p>
                        </div>
                        <div className="card1">
                            <p>Nessun personale aggiuntivo richiesto e supporto tecnico dedicato.</p>
                        </div>
                        <div className="card1">
                            <p>Promozione della tua boutique tramite i nostri canali social.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="how-it-works">
                <div className="container">
                    <h2>Benefici esclusivi per i Partner Totem Touch</h2>
                    <h5 className={"mt-5"} style={{fontSize: '20px'}}>Negozianti</h5>
                    <div className="cards-container">
                        <div className="card1">
                            <p>Nessuna gestione logistica e problematica di magazzino.</p>
                        </div>
                        <div className="card1">
                            <p>Shopping experience moderna e fluida per i clienti.</p>
                        </div>
                        <div className="card1">
                            <p>Posizionamento nel settore Fashion-Tech.</p>
                        </div>
                        <div className="card1">
                            <p>CRM dedicato per monitoraggio dati in tempo reale.</p>
                        </div>
                    </div>
                    <h5 className={"mt-5"} style={{fontSize: '20px'}}>Clienti</h5>
                    <div className="cards-container">
                        <div className="card1">
                            <p>Esplorazione digitale tramite Totem, con visualizzazione in tempo reale di varianti,
                                accessori e personalizzazioni scelte dal cliente.</p>
                        </div>
                        <div className="card1">
                            <p>Acquisto immediato e cashfree, senza passare dalla cassa, grazie a un sistema di
                                pagamento online sicuro e veloce.</p>
                        </div>
                        <div className="card1">
                            <p>Assistenza interattiva con indicazioni chiare su ogni passaggio del processo di
                                acquisto.</p>
                        </div>
                        <div className="card1">
                            <p>Servizio di chat diretta, per ricevere supporto in tempo reale senza bisogno di personale
                                dedicato.</p>
                        </div>
                    </div>
                </div>
            </section>

            <div>
                <section className="how-it-works">
                    <div className="container">
                        <h2>Un’Innovazione Tecnologica Che Si Integra Perfettamente nel tuo Negozio</h2>

                        <div className="d-flex justify-content-center align-items-center" style={{ gap: "5px", flexWrap: "nowrap" }}>
                            <img
                                src="img/TotemTouch2.jpg"
                                alt="Totem Touch"
                                className="img-fluid"
                                style={{ width: "50%" }}
                            />
                            <img
                                src="img/TotemTouch.jpg"
                                alt="Totem Touch"
                                className="img-fluid"
                                style={{ width: "50%" }}
                            />
                        </div>
                    </div>
                </section>
            </div>





            <section className="how-it-works">
                <div className="container">
                    <h2>Chi può diventare Partner Totem Touch?</h2>

                    <div className="row justify-content-center align-items-start">
                        <div className="col-12 col-md-5">
                            <h3>Se hai una fashion boutique, ecco i requisit ideali per diventare nostro partner:</h3>
                            <ul className="text-start">
                                <li>Boutique fisiche, concept store o showroom</li>
                                <li>Posizionamento settore premium/luxury</li>
                                <li>Multibrand di fascia medio-alta</li>
                                <li>Attività con visione estetica o cultura di nicchia</li>
                                <li>
                                    Non vendita di capi appartenenti alla tipologia fast fashion, bambini, casual,
                                    intimo e sposa
                                </li>
                            </ul>
                        </div>

                        <div className="col-12 col-md-5">
                            <h3>Non hai una fashion boutique?</h3>
                            <p className="mb-1">
                                Se hai un'altra attività, puoi comunque diventare partner.
                            </p>
                            <ul className="text-start">
                                <li>Tu ospiti il nostro Totem Touch nel tuo punto vendita attirando nuovi clienti.</li>
                                <li>Ogni volta che un cliente ordina tramite Totem, il negozio partner guadagna una commissione.</li>
                                <li>Ci occupiamo noi della gestione logistica.</li>
                                <li>Un modello win-win, dove entrambi cresciamo grazie alla collaborazione.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>


            {/* Sezione del form a cui si arriva con lo scroll */}
            <section
                ref={formRef}
                style={{paddingLeft: "2%", paddingRight: "2%", marginTop: "40px"}}
                className="container mb-5"
            >
                <link
                    href="https://campaign.huberway.com/core/css/embedded.css"
                    rel="stylesheet"
                    type="text/css"
                />
                <link
                    href="https://fonts.googleapis.com/icon?family=Material+Icons+Outlined"
                    rel="stylesheet"
                />
                <div className="subscribe-embedded-form">
                    <h2
                        style={{color: "black"}}
                        className="mt-0 text-center h_title wow fadeInUp"
                    >
                        CANDIDATURE APERTE
                    </h2>
                    <div className="media-body mb-5">
                        <h6
                            style={{color: "black", fontSize: "20px", fontWeight: "400"}}
                            className="text-center"
                        >
                            Saranno selezionate soltanto 20 Boutique sul territorio nazionale <br/> che riceveranno il
                            Totem Touch Interattivo in <br/> <b className="fWeigth">COMODATO D'USO GRATUITO!</b>
                        </h6>
                    </div>
                    <form
                        onSubmit={handleSubmit}
                        className="form-validate-jqueryz"
                        noValidate="novalidate"
                    >
                        <div className="form-group control-text">
                            <label>
                                Ragione Sociale <span className="text-danger">*</span>
                            </label>
                            <input
                                id="NAME"
                                placeholder=""
                                type="text"
                                name="NAME"
                                className="form-control required"
                                required
                            />
                        </div>
                        <div className="form-group control-text">
                            <label>
                                Referente <span className="text-danger">*</span>
                            </label>
                            <input
                                id="NOMINATIVO"
                                placeholder=""
                                type="text"
                                name="NOMINATIVO"
                                className="form-control required"
                                required
                            />
                        </div>
                        <div className="form-group control-text">
                            <label>
                                Nominativo Boutique <span className="text-danger">*</span>
                            </label>
                            <input
                                id="SHOP"
                                placeholder=""
                                type="text"
                                name="SHOP"
                                className="form-control required"
                                required
                            />
                        </div>
                        <div className="form-group control-text">
                            <label>
                                Indirizzo Boutique <span className="text-danger">*</span>
                            </label>
                            <input
                                id="LUOGO"
                                placeholder=""
                                type="text"
                                name="LUOGO"
                                className="form-control required"
                                required
                            />
                        </div>
                        <div className="form-group control-text">
                            <label>
                                Email <span className="text-danger">*</span>
                            </label>
                            <input
                                id="EMAIL"
                                placeholder=""
                                type="text"
                                name="EMAIL"
                                className="form-control required email:rfc,filter"
                                required
                            />
                        </div>
                        <div className="form-group control-text">
                            <label>
                                Recapito Telefonico <span className="text-danger">*</span>
                            </label>
                            <input
                                id="PHONE"
                                placeholder=""
                                type="text"
                                name="PHONE"
                                className="form-control required email:rfc,filter"
                                required
                            />
                        </div>
                        <div className="form-button text-center">
                            <button className="action_btn">Invia</button>
                        </div>
                    </form>
                </div>

                <div className="media-body mt-5">
                    {/* <h6
            style={{ color: "black", fontSize: "20px" }}
            className="text-center"
          >
            N.B. PER LE RICHIESTE A PARTIRE DAL 13/03/25 IL TOTEM TOUCH
            INTERATTIVO NON SARÀ PIÙ CONCESSO IN COMODATO D’USO GRATUITO
          </h6> */}
                </div>
            </section>
        </>
    );
}

export default TotemTouch;
